export const FREESTAR_LINKS_METADATA = [
    { rel: 'preconnect', href: 'https://a.pub.network/', crossOrigin: '' },
    { rel: 'preconnect', href: 'https://b.pub.network/', crossOrigin: '' },
    { rel: 'preconnect', href: 'https://c.pub.network/', crossOrigin: '' },
    { rel: 'preconnect', href: 'https://d.pub.network/', crossOrigin: '' },
    { rel: 'preconnect', href: 'https://c.amazon-adsystem.com', crossOrigin: '' },
    { rel: 'preconnect', href: 'https://s.amazon-adsystem.com', crossOrigin: '' },
    { rel: 'preconnect', href: 'https://btloader.com/', crossOrigin: '' },
    { rel: 'preconnect', href: 'https://api.btloader.com/', crossOrigin: '' },
    {
        rel: 'preconnect',
        href: 'https://cdn.confiant-integrations.net',
        crossOrigin: '',
    },
];
